import axios from "axios";
import { environment } from "../../environment";
import { isMobileApp } from "../../helpers/helpers";

declare global {
    interface Window {
        HartmanUserSignedInHandler: any;
        HartmanUserSignedOutHandler: any;
    }
}

const BASE_URL = environment.authUrl;

class AuthService {

    async sendPasswordToUser(user: any) {
        try {
            const path = environment.usersUrl + 'client/user/send_password_to_user';
            const res: any = await axios.post(path, user);
            return res;
        } catch (err) {
            throw err
        }
    }


    async isEmailVerified(email: string): Promise<boolean | string> {
        try {
            const res = await axios.get(environment.authUrl + 'auth/verify/' + email);
            if (res?.data && res.data.emailValid === true) {
                return true;
            } else {
                return false;
            }
        } catch (err) {
            throw err;
        }
    }

    registerMobileDevice(email: string, userId: string) {
        try {
            const jsonData = JSON.stringify({ userId, email }, null, 2);

            if (window.HartmanUserSignedInHandler?.postMessage) {
                window.HartmanUserSignedInHandler.postMessage(jsonData);
            } else {
                console.warn("[REGISTER MOBILE DEVICE] No mobile device registration handler found.");
            }

        } catch (error) {
            console.error("[REGISTER MOBILE DEVICE] Error:", error);
        }
    }


    async login(email: string, password: string) {
        console.log("[LOGIN] Attempting login with:", { email, password });
        console.log("[LOGIN] User Agent:", navigator.userAgent);

        try {
            this.clearAllUserData();
            
            const res = await axios.post(`${BASE_URL}auth/login`, {
                email,
                password,
                user_agent: navigator.userAgent
            })
            
            const { data } = res || {};
            const { access_token, me } = data || {};

            if (access_token && me) {
                console.log("[LOGIN] Successful. Storing token.");
                localStorage.setItem('token', access_token);

                if (isMobileApp()) {
                    console.log("[LOGIN] Detected HartmanApp. Registering mobile device.");
                    this.registerMobileDevice(me.email, me._id);
                }
                else {
                    console.log("[LOGIN] No mobile device registration found.");
                }
                return data;
            } else {
                console.error("[LOGIN] Failed: No access_token received.");
                throw new Error('No access_token received');
            }
        } catch (err) {
            throw err
        }
    }


    unRegisterMobileDevice(email: string, userId: string) {
        try {
            const jsonData = JSON.stringify({ userId, email });

            if(window.HartmanUserSignedOutHandler?.postMessage) {
                window.HartmanUserSignedOutHandler.postMessage(jsonData);
            } else {
                console.warn("[UNREGISTER MOBILE DEVICE] No mobile device unregistration handler found.");
            }
        } catch (error) {
            console.error("[UNREGISTER MOBILE DEVICE] Error:", error);
        }
    }

    clearAllUserData() {
        try {
            const keysToRemove = ['token', 'entityLanguage', 'currentPath'];
            keysToRemove.forEach(key => localStorage.removeItem(key));
            
            console.log("[CLEAR USER DATA] All user-related data cleared from localStorage");
        } catch (err) {
            console.error("[CLEAR USER DATA] Error:", err);
        }
    }

    logout(email: string, _id: string) {
        try {
            this.clearAllUserData();
            
            if (isMobileApp()) {
                this.unRegisterMobileDevice(email, _id);
            }
        } catch (err) {
            console.error("[LOGOUT] Error:", err);
            throw err
        }
    }


    async acceptTerms(email, _id) {
        try {
            return await axios.post(environment.authUrl + 'client/user/accept_terms', {
                email: email,
                _id: _id,
                user_agent: navigator.userAgent
            })

        } catch (err) {
            throw err
        }
    }

}


export default new AuthService() as AuthService;